import React from "react";
import Popover from "../../../../../common-deprecated/components/popover/aem/Popover";
import List from "../styles/atoms/List";
import { UscVehicleSaleType } from "../../../../shared-logic/types/UscCommonTypes";
import Icon from "../../../../shared-components/toyota/styles/atoms/Icon";
import * as ListStyles from "../styles/atoms/List.styles";

type PropsType = {
    listItems: { label: string; disclaimer?: string }[];
    vehicleSaleType: UscVehicleSaleType;
};

/**
 * Renders a list of labels with a checkmark icon and an optional disclaimer
 *
 */
const DescriptionLines = ({ listItems, vehicleSaleType }: PropsType): JSX.Element | null => {
    return (
        <List variant="custom-icon" columns={2}>
            {listItems.map(({ label, disclaimer }) => (
                <li key={label}>
                    <ListStyles.IconWrapper
                        color={vehicleSaleType === UscVehicleSaleType.Approved ? "primary-red" : "primary-black"}
                    >
                        <Icon variant={vehicleSaleType === UscVehicleSaleType.Approved ? "check" : "error"} />
                    </ListStyles.IconWrapper>
                    {label}
                    {disclaimer && (
                        // This doesnt use DisclaimerIcon on purpose.
                        // If this content is ever rendered in a PDF or needs footnotes (doubt it) consider migrating.
                        <Popover showOnClick content={disclaimer} />
                    )}
                </li>
            ))}
        </List>
    );
};

export default DescriptionLines;
